export default "__VITE_ASSET__CycKhnUu__$_?url__"